(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceVenduDeleteController',ServiceVenduDeleteController);

    ServiceVenduDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceVendu'];

    function ServiceVenduDeleteController($uibModalInstance, entity, ServiceVendu) {
        var vm = this;
        vm.serviceVendu = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ServiceVendu.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
